/**
 * File: MatchController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import imagePopup from '../views/popup/imagePopup.html'
import passagePopup from '../views/popup/passagePopup.html'
import commonShufflePopup from '../views/popup/mtf-preview.html'

class MatchController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state,CONSTANTS, CQuesConst,$mdDialog,uploadService,$mdMedia) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        //On destroy function
        this.$onDestroy = () => {
        }
        
        let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
        let userId = localStorageService.get("user_id")
        let USER_PATH = userId + "/question/"
        let schoolId = localStorageService.get("school_id")
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
        $scope.fileUrl = PREVIEW_URL
        let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
        let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
        let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
        let SAVE_URL = CQuesConst.API_CREATE_MTF
        $scope.isLatex = false
        $scope.content_editor_id = userId;
        let self = this;
        $scope.auto_shuffle = true
        $scope.shuffled_options = []
        /******* LIMIT FOR QUSTION CREATION *******/
        $scope.option_limit = CQuesConst.OPTION_LIMIT;
        $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
        $scope.explain_limit=CQuesConst.ANS_EXPLANATION_LIMIT;
        //SET UI FOR EDIT QUESTIONS
        $scope.options = [];
        this.alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        this.optionColors = ["#f3c301", "#2ab4bf", "#e74f5b", "#1bbc9d"];
        var calIndex = function(index, length) {
            if (index >= length) {
                if ((index - length) >= length)
                    return calIndex(index - length, length)
                else
                    return index - length;
            } else
                return index;
        }
        let editQuestion = $scope.$parent.$parent.editQuestion
        
        if (editQuestion && editQuestion.option) {
            if(!editQuestion.auto_shuffle && editQuestion.shuffled_options && editQuestion.shuffled_options.length){
                $scope.auto_shuffle = false
                $scope.shuffled_options = editQuestion.shuffled_options
            }
            //$scope.question = editQuestion.qn_desc;
            $scope._id = editQuestion._id;
            $scope.isEdit =  true;
            _.each(editQuestion.option, function(opt) {
                var colorIndex = calIndex($scope.options.length, 4);
                $scope.isLatex = editQuestion.isLatex
                $scope.options.push({
                    caption: opt.question ? opt.question.tag : '',
                    color: self.optionColors[colorIndex],
                    questionImg:  opt.question ? opt.question.questionImg : '',
                    choiceImg: opt.answer.optImage,
                    question: opt.question ? opt.question.desc : '',
                    answer: opt.answer.desc,
                    isLatex: $scope.isLatex,
                    explanation: opt.explanation
                })
            })
            $scope.created_dt = editQuestion.created_dt;
            $scope.content_editor_id = editQuestion.content_editor_id;
            $scope.selectedPassage_id = editQuestion.passage_id;
            if ($scope.selectedPassage_id) {
                $scope.selectedPassage = editQuestion.passage_detail;
            }
        }
        else {
            for (var i = 0; i < 4; i++) {
                let option = {
                    caption: this.alphabets[i],
                    color: this.optionColors[i],
                    questionImg: '',
                    choiceImg: '',
                    'question': '',
                    'answer': '',
                    'hint': '',
                    isLatex: false
                }
                $scope.options.push(option)
            }
        }
        //TO SET PASSAGE LIST
        var passageCallback = (resultObj) => {
            $scope.isPassagePresent = false;
            $scope.passages = []
            if (resultObj && resultObj.result && resultObj.result.data) {
                var result = resultObj.result.data.passage ? resultObj.result.data.passage : []
                if (result) {
                    if (result.length > 0) {
                        $scope.isPassagePresent = true;
                        _.each(result, function (eachPas) {
                            if ($scope.selectedPassage_id === eachPas._id) {
                                eachPas["isSelected"] = true
                            } else {
                                eachPas["isSelected"] = false
                            }
                        })
                        $scope.passages = result
                    }
                    _.defer(() => { $scope.$apply() })
                }
            }
        }
        let authoring = {
            curriculum_id: $scope.$parent.curriculum_id,
            class_id: $scope.$parent.class_id,
            subject_id: $scope.$parent.subject_id,
            school_id: schoolId,
            user_id: userId
        }
        authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback)

        
        var MQ = MathQuill.getInterface(2);
        //Invokes after the question elements loaded
        $scope.questionsLoaded = function(option) {
            var optionFieldSpan = document.getElementsByClassName('match-question-field');
            _.each(optionFieldSpan, function(spanElement) {
                spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched mathquill-editable'
                if (option.question) {
                    spanElement.textContent = option.question
                }
                var optionField = MQ.MathField(spanElement, {
                    spaceBehavesLikeTab: false,
                    restrictMismatchedBrackets: true,
                    handlers: {
                        edit: function() {
                            option.question = optionField.latex()
                        }
                    }
                });
            })
        }
         //Invokes after the answer elements loaded
         $scope.answersLoaded = function(option) {
            var optionFieldSpan = document.getElementsByClassName('match-answer-field');
            _.each(optionFieldSpan, function(spanElement) {
                spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
                if (option.answer) {
                    spanElement.textContent = option.answer
                }
                var optionField = MQ.MathField(spanElement, {
                    spaceBehavesLikeTab: false,
                    restrictMismatchedBrackets: true,
                    handlers: {
                        edit: function() {
                            option.answer = optionField.latex()
                        }
                    }
                });
            })
        }

        //Invokes after the explanation elements loaded
        $scope.explanationsLoaded = function(option) {
            var optionFieldSpan = document.getElementsByClassName('match-explanation-field');
            _.each(optionFieldSpan, function(spanElement) {
                spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
                if (option.explanation) {
                    spanElement.textContent = option.explanation
                }
                var optionField = MQ.MathField(spanElement, {
                    spaceBehavesLikeTab: false,
                    restrictMismatchedBrackets: true,
                    handlers: {
                        edit: function() {
                            option.explanation = optionField.latex()
                        }
                    }
                });
            })
        }
           
        //PREVENT PASTE FUNCTIONALITY
        $scope.paste = function (e) {
            e.preventDefault();
            return false
        }
        //to add new options
        $scope.addOption = function(index) {
            var alphaIndex = calIndex($scope.options.length, 26);
            var colorIndex = calIndex($scope.options.length, 4);
            var option = {
                'caption': self.alphabets[alphaIndex],
                'color': self.optionColors[colorIndex],
                'questionImg': '',
                'choiceImg': '',
                'question': '',
                'answer': '',
                'hint': '',
                'isLatex': false
            }
            $scope.options.push(option)
        }
         //to remove options
        $scope.removeOption = function(index) {
            if ($scope.options.length == 1) {
                return false;
            } else {
                var tempOptions = [];
                angular.copy($scope.options, tempOptions)
                for (var i = 0; i < $scope.options.length; i++) {
                    if (i > index) {
                        $scope.options[i].caption = tempOptions[i - 1].caption;
                        $scope.options[i].color = tempOptions[i - 1].color;
                    }
                }
                $scope.options.splice(index, 1)
            }
        }
        //Image upload for question
        $scope.uploadQuestionImg = function(file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function(fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                      uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result)
                      {
                        if (result.url) {
                            _.each($scope.options, function(key, val) {
                                if ($scope.options[val].caption === opt.caption) {
                                    $scope.options[val].questionImg = result.url
                                }
                            })
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        $scope.removeQuestionImg = function(index) {
            $scope.options[index].questionImg = undefined;
        }

         $scope.removeChoiceImg = function(index) {
            $scope.options[index].choiceImg = undefined;
        }

        //Image upload for choice
        $scope.uploadChoiceImg = function(file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function(fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                      uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result)
                      {
                        if (result.url) {
                            _.each($scope.options, function(key, val) {
                                if ($scope.options[val].caption === opt.caption) {
                                    $scope.options[val].choiceImg = result.url
                                }
                            })
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        //DIALOG CONTROLLER FOR IMAGE
        var imageDialogCtrl = function ($scope, $mdDialog, imageViewType, imageDetails) {
            $scope.fileUrl = PREVIEW_URL
            $scope.isPassage = false;
            $scope.title = imageDetails.title;
            $scope.imageArray = imageDetails.images;
            $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false

            $scope.deleteImage = function (imageIndex) {
                $scope.imageArray.splice(imageIndex, 1)
            }
            $scope.cancelDialog = function () {
                $mdDialog.cancel();
                if (imageViewType === 'question') {
                    $scope.questionImage = $scope.imageArray
                } else if (imageViewType === 'explan') {
                    $scope.explanationImage = $scope.imageArray
                } else if (imageViewType === 'answer') {
                    $scope.descImage = $scope.imageArray
                }
                $scope.imageArray = []
            };
        }
        $scope.cancelSelectedPasssage = function () {

            $scope.selectedPassage = null
            _.each($scope.passages, function (eachPas) {
                eachPas.isSelected=false
            })
          }
        //Open dialog to view image
        $scope.openDialog = (imageType) => {
            let imageDetails;
            if (imageType === 'question') {
                imageDetails = {
                    title: "OWQ - Question Image",
                    images: $scope.questionImage
                }
            } else if (imageType === 'explan') {
                imageDetails = {
                    title: "OWQ - Explanation Image",
                    images: $scope.explanationImage
                }
            } else if (imageType === 'answer') {
                imageDetails = {
                    title: "OWQ - Answer Image",
                    images: $scope.descImage
                }
            }
            else if (imageType === 'passage') {
                imageDetails = {
                    title: "OWQ - Passage Image",
                    images: $scope.selectedPassage.passage_image,
                    isPassage: true
                }
            }
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                locals: {
                    imageViewType: imageType,
                    imageDetails: imageDetails
                },
                template: imagePopup,
                controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        }

        var setPassage = () => {            
            $scope.selectedPassage = _.find($scope.passages,function(pas){
                return pas.isSelected
            })
        }

        //DIALOG CONTROLLER FOR PASSAGE
        var passageDialogCtrl = function ($scope, $mdDialog, passages) {
            $scope.passages = passages
            $scope.fileUrl = PREVIEW_URL
            $scope.isArray = function (obj) {
                return Array.isArray(obj);
            }
            /*
             * Function to cancel dialog to select passage
             */
            $scope.cancelPassage = function () {
                $mdDialog.cancel();
                setPassage()
            };


            
              /*
             * Function to select passage
             */
            $scope.selectPassage = function (passage_id) {
                _.each($scope.passages, function (eachPas) {
                  if (eachPas._id !=passage_id) {
                    eachPas.isSelected = false;
                  }
                })
                $scope.cancelPassage()
              }

        }
       

        /*
         * Function to open dialog to select passage
         */
        $scope.openPassage = () => {
            if(!$scope.passages)
            {
                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('No Passage')
                    .textContent('Passages not loaded.Try after some time.')
                    .ariaLabel('Passage Dialog')
                    .ok('Ok')
                );
            }
           else
            {
                if($scope.passages.length==0)
               {
                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('No Passage')
                    .textContent('No passages added yet. Please add passage and link it')
                    .ariaLabel('Passage Dialog')
                    .ok('Ok')
                );
               }
        
           else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: passagePopup,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                })
            }
        }
        }

        //Adding OWQ question from UI
        $scope.$on('addMatchQuestion', function () {
            $scope.errors = {}
            let details = localStorageService.get("questionDetails")
            let question = details.question
            let activityErrorCount = details.errorCount;
            let questionArr = []
            let answerArr = []
            let duplicateOptCnt = 0
            let dupeAnswerCnt = 0
            //Validation  
            if ($scope.options) {
                let noQuestion = 0
                _.each($scope.options, function(opt, index) {
                    if ($scope.isPractice) {
                        if (opt.explanation == null || opt.explanation == undefined || opt.explanation == "") {
                            $scope.errors["option." + index + ".explanation"] = "Hint is required"
                            $scope.activityErrorCount++;
                        }
                    }
                    if (opt.explanation && opt.explanation.length > $scope.explain_limit) {
                        $scope.errors["option." + index + ".explanation"] = "Hint does not exceed " + CQuesConst.ANS_EXPLANATION_LIMIT + " characters";
                        $scope.activityErrorCount++;
                    }
                    if (opt.question == null || opt.question == undefined || opt.question == "") {
                        noQuestion++
                    } else if (opt.question.length > $scope.option_limit) {
                        $scope.errors["option." + index + ".question"] = "Question does not exceed " + $scope.option_limit + " characters"
                        $scope.activityErrorCount++;
                    }
                    if (opt.answer == null || opt.answer == undefined || opt.answer == "") {
                        $scope.errors["option." + index + ".answer"] = "Answer is required"
                        $scope.activityErrorCount++;
                    } else if (opt.answer.length > $scope.option_limit) {
                        $scope.errors["option." + index + ".answer"] = "Answer does not exceeds " + $scope.option_limit + " characters"
                        $scope.activityErrorCount++;
                    }
                    if (opt.question) {
                        if (questionArr.indexOf(opt.question) === -1) {
                            questionArr.push(opt.question)
                        } else {
                            duplicateOptCnt++
                        }
                    }
                    if (opt.answer) {
                        if (answerArr.indexOf(opt.answer) === -1) {
                            answerArr.push(opt.answer)
                        } else {
                            dupeAnswerCnt++
                        }
                    }
                })
                if(noQuestion == $scope.options.length){
                    $scope.activityErrorCount++;
                    toastr.error("Please enter atleast one question")
                    return false
                }
                if (duplicateOptCnt > 0) {
                    $scope.errors['duplicateQues'] = "Qusetion is repeated."
                    $scope.activityErrorCount++;
                }
                if (dupeAnswerCnt > 0) {
                    $scope.errors["duplicateAns"] = "Answer is repeated."
                    $scope.activityErrorCount++;
                }
            }
            if (activityErrorCount === 0) {
                $scope.$parent.isSaveClicked = true;
                if($scope.auto_shuffle && !$scope.shuffled_options.length){
                    $scope.auto_shuffle = false
                }
                console.log($scope.shuffled_options)
                let obj = {
                    "_id": $scope._id,
                    "question_theme_id": question.theme._id,
                    "question_theme_name": question.theme.name,
                    "option": angular.copy($scope.options),
                    "strand": question.strand,
                    "tag": question.tag,
                    "wave": question.wave,
                    "qn_desc": '' + 'Match the following',
                    "isLatex": $scope.isLatex,
                    "level": question.level,
                    "subject_id": question.subject_id,
                    "school_id": question.school_id,
                    "questionImg": $scope.questionImage,
                    "session_id": question.session_id,
                    "batch_id": question.batch_id,
                    "class_id": question.class_id,
                    "curriculum_id": question.curriculum_id,
                    "xlink": question.link_theme,
                    "cognitive_skills": question.cognitive_skill,
                    "isNotAddToQp": question.isNotAddToQp,
                    "is_traditional_activity": question.is_traditional_activity,
                    "qp_id": question.qp_id,
                    "created_dt": $scope.created_dt,
                    "content_editor_id": $scope.content_editor_id,
                    "activity_id": question.activity_id,
                    "user_id": userId,
                    "passage": $scope.selectedPassage,
                    "teaching_plan_id": question.teaching_plan_id,
                    "shuffled_options" : $scope.shuffled_options,
                    "auto_shuffle" : $scope.auto_shuffle
                }
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    let result = resObj.result
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        $rootScope.resetValues()
                        if (question.is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: question.qp_id
                            })
                            toastr.success("Question Saved successfully");
                        }else if(question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== ""){
                            $state.go('formatQp', {
                                resourceId: question.activity_id
                            })
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession()
                            }
                        }
                    } else {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        toastr.error("Network Error")
                    }
                    _.defer(() => { $scope.$apply() })
                })
            } else {
                $rootScope.setHideSaveButton(false)
                $rootScope.setLoader(false)
                toastr.error("Please fill all mandatory fields")
            }
        })
        $scope.setShuffledOPtvar = (options) => {
            $scope.shuffled_options = options
            console.log($scope.shuffled_options)
        }
        function validateB4Shuffle(){
        
            let options = $scope.options, RHSerror = 0, ret_val = true, LHSerror = 0
            for(let o = 0; o < options.length; o++){
                if(!options[o].answer){
                    RHSerror++
                }
                if(!options[o].question){
                    LHSerror++
                }
            }
            if(RHSerror){
                ret_val = false
                toastr.error("Please enter all answers.!")
            }
            if(LHSerror && LHSerror == options.length){
                ret_val = false
                toastr.error("Please enter atleast one option!")
            }
            return ret_val
        }
        $scope.showPreview = (shuffle_enabled, ev) => {
            if(!$scope.auto_shuffle){
                let proceed = validateB4Shuffle()
                if(proceed){
                    $mdDialog.show({
                        controller: ['$scope', '$mdDialog', 'options', 'parentScope', 'editQuestion', 'fileUrl',
                        'client_shuffled_options',
                        commonShuffleCtrl],
                        locals: {
                            options : $scope.options,
                            parentScope : $scope,
                            editQuestion : editQuestion,
                            fileUrl : $scope.fileUrl,
                            client_shuffled_options : $scope.shuffled_options
                        },
                        template: commonShufflePopup,
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        targetEvent : ev
                        // fullscreen: useFullScreen
                    })
                }else{
                    $scope.auto_shuffle = true
                }
            }
        }
    }
}


export default MatchController;

class commonShuffleCtrl {
    constructor($scope, $mdDialog, options, parentScope, editQuestion, fileUrl, client_shuffled_options) {
        $scope.options = []
        $scope.question = {
            options : [],
            shuffled_options : []
        }
        $scope.fileUrl = fileUrl
        $scope.ret_val = []
        function createShuffle(){
            for(let o = 0; o < options.length; o++){
                let question = {
                    tag : options[o].caption,
                    desc : options[o].question,
                    questionImg : options[o].questionImg
                }
                let answer = {
                    tag : o + 1,
                    desc : options[o].answer,
                    optImage : options[o].choiceImg
                }
                let obj = {
                    question : question,
                    answer : answer,
                    index : o
                }
                $scope.question.shuffled_options.push(obj)
                $scope.question.options.push(options[o])
            }
        }
        function createShuffleOnEdit(editQuestion, mode){
            let shuffled_options = editQuestion.shuffled_options
            for(let s = 0; s < shuffled_options.length; s++){
                let option_exists = _.find(options, function(one){
                    return one.caption == shuffled_options[s].mtf_question_tag
                })
                if(option_exists){
                    let question = {
                        tag : option_exists.caption,
                        desc : option_exists.question,
                        questionImg : option_exists.questionImg
                    }
                    let answer = {
                        tag : s + 1,
                        desc : option_exists.answer,
                        optImage : option_exists.choiceImg
                    }
                    let obj = {
                        question : question,
                        answer : answer,
                        index : s
                    }
                    $scope.question.shuffled_options.push(obj)
                }
            }
            for(let o = 0; o < options.length; o++){
                $scope.question.options.push(options[o])
            }
        }
        this.$onInit = () => {
            if(editQuestion && !editQuestion.auto_shuffle && editQuestion.shuffled_options && editQuestion.shuffled_options.length){
                if(client_shuffled_options && client_shuffled_options.length){
                    let obj = {
                        shuffled_options : client_shuffled_options
                    }
                    createShuffleOnEdit(obj, "editButFromClient")
                }else{
                    createShuffleOnEdit(editQuestion, "db_edit_only")
                }
            }else{
                if(client_shuffled_options && client_shuffled_options.length){
                    let obj = {
                        shuffled_options : client_shuffled_options
                    }
                    createShuffleOnEdit(obj, "b4createquestion")
                }else{
                    createShuffle()
                }
            }
        }
        $scope.sortableOptions = {
            containment: '#sortable-container'
        };
        function setTagNpos(isSave){
            let shuffled_options = $scope.question.shuffled_options
            $scope.ret_val = [] 
            for(let s = 0; s < shuffled_options.length; s++){
                let obj = {
                    tag : shuffled_options[s].answer.tag,
                    desc : shuffled_options[s].answer.desc,
                    optImage : shuffled_options[s].answer.optImage,
                    mtf_question_tag : shuffled_options[s].question.tag
                }
                $scope.ret_val.push(obj)
            }
            if(isSave){
                return $scope.ret_val
            }
        }
        $scope.dragControlListeners = {
            containment: '#sortable-container',
            allowDuplicates: true,
            ctrlClone: true,
            orderChanged: function(event) {
            },
            dragStart: function() {
            },
            dragEnd: function() {
                setTagNpos()
            },
            accept: function(sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            },
            itemMoved: function(event) {
                event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
            }
        };

        $scope.saveAction = () => {
            let array = setTagNpos(true)
            if(array && array.length){
                toastr.success("Shuffle order saved")
                parentScope.setShuffledOPtvar(array)
                $mdDialog.hide();
            }
        }
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        
    }
}


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/matchController.js